import { createEnv } from "@t3-oss/env-nextjs";
import { vercel } from "@t3-oss/env-nextjs/presets-zod";
import { z } from "zod/v4";

export const env = createEnv({
  extends: [vercel()],
  shared: {
    NODE_ENV: z
      .enum(["development", "production", "test"])
      .default("development"),
    NEXT_PUBLIC_SUPABASE_URL: z.string().optional(),
    NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY: z.string().optional(),
  },
  /**
   * Specify your server-side environment variables schema here.
   * This way you can ensure the app isn't built with invalid env vars.
   */
  server: {
    GOOGLE_MAPS_KEY: z.string(),
    OPENAI_KEY: z.string(),
    ANTHROPIC_KEY: z.string().optional(),
    STRAPI_ENDPOINT: z.string().optional(),
    STRAPI_API_KEY: z.string().optional(),
  },

  /**
   * Specify your client-side environment variables schema here.
   * For them to be exposed to the client, prefix them with `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_SUPABASE_URL: z.string().optional(),
    // Set by next.config.js from the build's commit, so it is absent when
    // env.ts is validated at config load. Optional on purpose.
    NEXT_PUBLIC_APP_RELEASE: z.string().optional(),
    NEXT_PUBLIC_APP_VERSION: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_API_HOST: z.string().optional(),
    // Read by `configureSentryClient`, which instrumentation-client calls.
    // Optional: without it the shared init returns before Sentry.init.
    NEXT_PUBLIC_SENTRY_DSN: z.string().optional(),
  },
  /**
   * Destructure all variables from `process.env` to make sure they aren't tree-shaken away.
   */
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY:
      process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY,
    NEXT_PUBLIC_APP_RELEASE: process.env.NEXT_PUBLIC_APP_RELEASE,
    NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
    NEXT_PUBLIC_POSTHOG_API_KEY: process.env.NEXT_PUBLIC_POSTHOG_API_KEY,
    NEXT_PUBLIC_POSTHOG_API_HOST: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  },
  // Vercel sets CI as well, and it is the only build holding the real values,
  // so skipping there let a missing variable ship and fail in the browser.
  // GitHub Actions builds from .env.example placeholders and must keep
  // skipping, which is what the VERCEL check separates.
  // lint and typecheck build nothing, and typegen swallowed the throw anyway.
  skipValidation:
    (!!process.env.CI && !process.env.VERCEL) ||
    ["lint", "typecheck"].includes(process.env.npm_lifecycle_event ?? ""),
});
